import { makeStyles } from '@material-ui/core/styles';
import { timeInStatusTiers, timeInStatusTierColors, timeInStatusTierBgColors } from './timeInStatusConsts';

export const useTimeInStatusBadgeStyles = makeStyles(() => ({
    badge: {
        display: 'inline-block',
        maxWidth: '100%',
        padding: '0.2em 0.85em',
        borderRadius: 8,
        border: '1px solid',
        fontWeight: 400,
        fontSize: '0.8rem',
        lineHeight: 1.5,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    [`tier${timeInStatusTiers.NoThreshold}`]: {
        color: timeInStatusTierColors[timeInStatusTiers.NoThreshold],
        borderColor: timeInStatusTierColors[timeInStatusTiers.NoThreshold],
        backgroundColor: timeInStatusTierBgColors[timeInStatusTiers.NoThreshold],
    },
    [`tier${timeInStatusTiers.WithinThreshold}`]: {
        color: timeInStatusTierColors[timeInStatusTiers.WithinThreshold],
        borderColor: timeInStatusTierColors[timeInStatusTiers.WithinThreshold],
        backgroundColor: timeInStatusTierBgColors[timeInStatusTiers.WithinThreshold],
    },
    [`tier${timeInStatusTiers.Approaching}`]: {
        color: timeInStatusTierColors[timeInStatusTiers.Approaching],
        borderColor: timeInStatusTierColors[timeInStatusTiers.Approaching],
        backgroundColor: timeInStatusTierBgColors[timeInStatusTiers.Approaching],
    },
    [`tier${timeInStatusTiers.Breached}`]: {
        color: timeInStatusTierColors[timeInStatusTiers.Breached],
        borderColor: timeInStatusTierColors[timeInStatusTiers.Breached],
        backgroundColor: timeInStatusTierBgColors[timeInStatusTiers.Breached],
    },
}));
